// SuperWeek season config — THE single source of truth for the current year.
//
// This is the one file to edit on the yearly rollover (plus index.html meta
// and the Terms year — see the "Year rollover" section in AGENTS.md).
// Consumed by the Vercel functions (api/), the site (src/), and scripts/.
// Keep shared/season.d.ts in sync when the shape changes.

export const SEASON = {
  year: 2027,

  // false = coming-soon mode: the site shows an info card instead of the
  // form and api/register.js rejects submissions. Flip to true to open.
  registrationOpen: false,

  teenDays: ['2027-07-12', '2027-07-13'], // Mon, Tue
  setupDay: '2027-07-14', // Wed — break / setup day
  kidsDays: ['2027-07-15', '2027-07-16'], // Thu, Fri
  jointDay: '2027-07-17', // Sat — joint final event

  weekRange: '12.–17. jūlijs, 2027',
  jointDayHuman: '17. jūlijā', // "Sestdien, 17. jūlijā …"

  groups: {
    teens: {
      label: 'Pusaudži 13+',
      ageLabel: '13+ gadi',
      minAge: 13,
      capacity: 50,
      dates: '12.–13. jūlijs',
      datesWithYear: '12.–13. jūlijs, 2027',
      weekdaysShort: 'pirmd.–otrd.',
      weekdaysLong: 'pirmdiena – otrdiena',
    },
    kids: {
      label: 'Bērni līdz 12 g.',
      ageLabel: 'līdz 12 gadiem',
      maxAge: 12,
      capacity: 100,
      dates: '15.–16. jūlijs',
      datesWithYear: '15.–16. jūlijs, 2027',
      weekdaysShort: 'ceturtd.–piektd.',
      weekdaysLong: 'ceturtdiena – piektdiena',
    },
  },
};

// Firestore collection names — always derived from the year so the whole
// stack (API, admin board realtime listeners, scripts) rolls over together.
export const COLLECTIONS = {
  kids: `registrations_kids_${SEASON.year}`,
  teens: `registrations_teens_${SEASON.year}`,
  items: `admin_items_${SEASON.year}`,
  teams: `admin_teams_${SEASON.year}`,
  people: `admin_people_${SEASON.year}`,
  equipment: `admin_equipment_${SEASON.year}`,
};

// Chronological board week for the admin planning tool (incl. setup day).
export const PROGRAM_DAYS = [
  ...SEASON.teenDays,
  SEASON.setupDay,
  ...SEASON.kidsDays,
  SEASON.jointDay,
];
